import React from 'react';
import styled from 'styled-components';

import FAQItem from './FAQItem';
import SectionTitle from './SectionTitle';

export const FAQ = [
  {
    question: 'Is Shido GDPR compliant?',
    answer:
      'Yes, Shido fully complies with GDPR regulations. We prioritise data privacy and ensure all user information is handled in accordance with legal requirements.',
  },
  {
    question: 'Is my data secure and encrypted?',
    answer:
      'Absolutely. All your data is encrypted both in transit and at rest, ensuring it remains safe and secure at all times.',
  },
  {
    question: 'Can my employer see my data?',
    answer:
      "No, never. An individual's data is strictly private and visible only to them.",
  },
  {
    question: 'What email address should I use to sign up?',
    answer:
      'You can use any personal email address you like. Your Shido account is personal to you and is not linked to your workplace email address.',
  },
  {
    question: 'Does Shido integrate with wearables and existing tools?',
    answer:
      'Yes, Shido connects seamlessly with popular wearable devices like Fitbit, Google Fit, and HealthKit. This provides you with a centralised platform for tracking your wellness.',
  },
  {
    question: 'How much does it cost me?',
    answer:
      'Nothing. £0.00. This is a gift provided to you by your employer. No payment details required.',
  },
  {
    question: 'What if I need help with the app?',
    answer:
      'Shido offers dedicated support for all users. You can access help directly through the app or via our support team.',
  },
  {
    question: 'What happens to my Shido account if I leave the business?',
    answer:
      'Shido accounts are personal and belong to the individual, not the business. You will retain full use of your account until the access code expires.\nIf you leave your organisation, you can continue your Shido journey by purchasing an individual subscription or activating a new access code from your next employer.',
  },
];

const FAQSection = () => (
  <Container>
    <SectionTitle>Employee FAQ</SectionTitle>
    <Questions>
      {FAQ.map(({ answer, question }) => (
        <FAQItem key={question} answer={answer} question={question} />
      ))}
    </Questions>
  </Container>
);

const Questions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 21px;
  width: 100%;
  margin: 30px auto 0;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    width: auto;
    padding: 0 20px;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    margin-top: 0;
  }
`;

const Container = styled.section`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 78px 0;
  max-width: 1400px;
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px dashed rgba(65 78 113 / 25%);

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 34px 0;
  }
`;

export default FAQSection;
